const TOKEN_STORAGE_KEY = 'webmonitor_auth_token_v1';
const USER_STORAGE_KEY = 'webmonitor_auth_user_v1';

const safeWindow = () => (typeof window !== 'undefined' ? window : null);

export const getAuthToken = () => {
  const win = safeWindow();
  if (!win) return null;
  return win.localStorage.getItem(TOKEN_STORAGE_KEY);
};

export const saveAuthSession = ({ token, user }) => {
  const win = safeWindow();
  if (!win) return;
  if (token) {
    win.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }
  if (user) {
    win.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  }
};

export const getStoredUser = () => {
  const win = safeWindow();
  if (!win) return null;
  try {
    const raw = win.localStorage.getItem(USER_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearAuthSession = () => {
  const win = safeWindow();
  if (!win) return;
  win.localStorage.removeItem(TOKEN_STORAGE_KEY);
  win.localStorage.removeItem(USER_STORAGE_KEY);
};








